import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mobile-close",
  "use": "icon-mobile-close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-mobile-close\">\n    <path d=\"m18.894 4.045 1.061 1.06L13.06 12l6.895 6.894-1.06 1.061L12 13.06l-6.894 6.895-1.061-1.06L10.94 12 4.045 5.106l1.06-1.061 5.834 5.834v2.119l1.059-1.06.002.002 6.894-6.895z\" fill=\"#000018\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol